export { Sparkline, type SparklineProps } from './Sparkline'
